import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Modal from "react-modal";
import { apiUrl } from "../../config/config";
import { Toaster, toast } from "react-hot-toast";
// TopNav removed per design requirements
import SideBar from "../common/SideBar";

Modal.setAppElement("#root");

const BatteryIssue = () => {
  const [patients, setPatients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showBatteryModal, setShowBatteryModal] = useState(false);
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [batteryData, setBatteryData] = useState([]);
  const [loadingBattery, setLoadingBattery] = useState(false);
  const [commentsText, setCommentsText] = useState("");        // existing comment history
  const [newComment, setNewComment] = useState("");            // new entry being typed
  const [loadingComments, setLoadingComments] = useState(false);
  const [savingComments, setSavingComments] = useState(false);
  const [callbackStatusMap, setCallbackStatusMap] = useState(() => {
    try {
      const saved = localStorage.getItem("batteryIssueCallbackStatus");
      return saved ? JSON.parse(saved) : {};
    } catch (error) {
      return {};
    }
  });

  const rowsPerPage = 20;

  const menus = [
    { title: "Verifier Home", url: "/verifier-home" },
    { title: "Patient list", url: "/patient-list" },
    { title: "Labled Patients", url: "/labled-patients" },
    { title: "Verified", url: "/verification-completed" },
  ];

  if (localStorage.getItem("verifiertype") === "8") {
    menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
  }

  if (localStorage.getItem("AdminUser") === "8") {
    menus.splice(3, 0, { title: "Device Details", url: "/device-details" });
    menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
  }

  if (localStorage.getItem("verifiertype") === "8") {
    menus.splice(5, 0, { title: "Support Home", url: "/support-home" });
  }
  if (localStorage.getItem("verifiertype") === "8") {
    menus.splice(6, 0, { title: "QC Home", url: "/qc_home" });
  }
  if (localStorage.getItem("AdminUser") === "8") {
    menus.splice(7, 0, { title: "Report Shared", url: "/report-shared" });
  }
  if (localStorage.getItem("AdminUser") === "8") {
    menus.splice(7, 0, {
      title: "Supported Person",
      url: "/supported-persons",
    });
  }
  if (localStorage.getItem("AdminUser") === "8") {
    menus.splice(7, 0, {
      title: "Reset Password",
      url: "/ResetPassword",
    });
  }

  useEffect(() => {
    fetchPatients();
  }, []);

  const fetchPatients = async () => {
    try {
      const fullUrl = `${apiUrl}api/users/GetBatteryIssueDetails`;
      console.log("[BatteryIssue] GET", fullUrl);
      const response = await axios.get(fullUrl);
      const normalizedPatients = Array.isArray(response.data)
        ? response.data.reverse().map((device) => ({
            ...device,
            Mac_id: device.Mac_id || device.mac_id || "",
            mac_id: device.mac_id || device.Mac_id || "",
            device_id: device.device_id || device.deviceId || "",
            customer_name:
              device.customer_name ||
              device.customerName ||
              device.customer_details ||
              "",
            bat_start:
              device.bat_start || device.Bat_start || device.battery_start || "",
            bat_end:
              device.bat_end || device.Bat_end || device.battery_end || "",
            bat_stat:
              device.bat_status ||
              device.bat_stat ||
              device.Bat_status ||
              device.status ||
              "",
            callbacked_verifiername:
              device.callbacked_verifiername ||
              
              "",
            callback_status: device.callback_status || "",
          }))
        : Array.isArray(response.data?.patients)
          ? response.data.patients
          : [];

      setPatients(normalizedPatients);
    } catch (error) {
      // Surface the *real* cause so we can see whether it's CORS, 404, 500, or a parse error.
      const status = error.response?.status;
      const data = error.response?.data;
      const serverMsg =
        (typeof data === "string" && data) ||
        data?.message ||
        (typeof data?.details === "string" ? data.details : "") ||
        error.message ||
        "unknown";

      console.error("[BatteryIssue] fetch failed", {
        status,
        serverMsg,
        data,
        url: error.config?.url,
        method: error.config?.method,
        fullError: error,
      });

      const headline = status
        ? `Battery API ${status}: ${serverMsg}`
        : `Battery API unreachable: ${serverMsg}`;
      toast.error(headline, { duration: 6000 });
    }
  };

  const getCustomerText = (patient) => {
    if (
      typeof patient.customer_details === "string" &&
      patient.customer_details.trim()
    ) {
      return patient.customer_details;
    }

    if (patient.customer_name && patient.customer_name !== "NA") {
      return patient.customer_name;
    }

    if (patient.customerName && patient.customerName !== "NA") {
      return patient.customerName;
    }

    if (
      Array.isArray(patient.customer_details) &&
      patient.customer_details.length > 0
    ) {
      return patient.customer_details
        .map((item) => item.customer_details)
        .filter(Boolean)
        .join(", ");
    }

    return "_";
  };

  const getBatteryMacId = (row) => {
    if (!row) {
      return "";
    }

    return row.Mac_id || row.mac_id || "";
  };

  const getCallbackStatusKey = (row) => {
    if (!row) {
      return "";
    }

    const macId = row.Mac_id || row.mac_id || "";
    const deviceId = row.device_id || row.deviceId || "";

    return `${macId}::${deviceId}`;
  };

  const filteredRows = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();

    // Helper to read the battery status from any of the field-name variants the
    // backend may send (bat_status / bat_stat / Bat_status).
    const getBatStatus = (patient) =>
      (patient.bat_status || patient.bat_stat || patient.Bat_status || "")
        .toString()
        .trim()
        .toLowerCase();

    // Show only "Not Ideal" devices on this page — Ideal devices are filtered out.
    const notIdealOnly = patients.filter(
      (patient) => getBatStatus(patient) === "not ideal"
    );

    const filtered = !query
      ? notIdealOnly
      : notIdealOnly.filter((patient) => {
          const values = [
            patient.serial_no,
            patient.mac_id,
            patient.Mac_id,
            getCustomerText(patient),
            patient.bat_start,
            patient.bat_end,
            patient.bat_status,
            patient.bat_stat,
            patient.Bat_status,
            patient.callbacked_verifiername,
            patient.callback_status,
          ];

          return values.some(
            (value) => value && value.toString().toLowerCase().includes(query)
          );
        });

    // Within the Not-Ideal set, push items still needing callback to the top.
    const getPriority = (patient) => {
      const callbackStatus = (patient.callback_status || "").toLowerCase();
      if (callbackStatus === "yes") return 1; // already called — lower priority
      return 0;                                // pending callback — top
    };

    return [...filtered].sort((a, b) => getPriority(a) - getPriority(b));
  }, [patients, searchQuery]);

  const totalPages = Math.max(1, Math.ceil(filteredRows.length / rowsPerPage));
  const startIndex = (currentPage - 1) * rowsPerPage;
  const displayedRows = filteredRows.slice(startIndex, startIndex + rowsPerPage);

  const handleView = async (patient) => {
    try {
      setSelectedPatient(patient);
      setShowBatteryModal(true);
      setLoadingBattery(true);
      setBatteryData([]);

      const macId = patient.Mac_id || patient.mac_id;

      if (!macId) {
        setBatteryData([]);
        toast.error("MAC ID not found");
        return;
      }

      const res = await axios.get(
        `${apiUrl}api/users/getBatteryHistoryByMacId`,
        {
          params: {
            mac_id: macId,
          },
        }
      );

      setBatteryData(
        res.data && Array.isArray(res.data.data) ? res.data.data : []
      );
    } catch (error) {
      console.error("Error fetching battery history", error);
      setBatteryData([]);
      toast.error("Error fetching battery history");
    } finally {
      setLoadingBattery(false);
    }
  };

  const handleCallbackStatusChange = async (patient, value) => {
    const callbackKey = getCallbackStatusKey(patient);

    setCallbackStatusMap((prev) => {
      const updated = {
        ...prev,
        [callbackKey]: value,
      };
      localStorage.setItem(
        "batteryIssueCallbackStatus",
        JSON.stringify(updated)
      );
      return updated;
    });

    try {
      const verifierName = localStorage.getItem("verifiername") || "NA";

      await axios.post(`${apiUrl}api/users/saveCallbackedPerson`, {
        mac_id: patient.Mac_id || patient.mac_id || "",
        device_id: patient.device_id || patient.deviceId || "",
        callback_status: value,
        callbacked_verifiername: verifierName,
      });

      setPatients((prev) =>
        prev.map((row) =>
          getCallbackStatusKey(row) === callbackKey
            ? {
                ...row,
                callbacked_verifiername: verifierName,
                callback_status: value,
              }
            : row
        )
      );
    } catch (error) {
      console.error("Error saving callback status:", error);
      toast.error("Error saving callback status");
    }
  };

  const handleCommentsOpen = async (patient) => {
    setSelectedPatient(patient);
    setShowCommentsModal(true);
    setCommentsText("");
    setNewComment("");

    // Per-device comments — stored on the Deviceinfo record by mac_id.
    // Same source used by /device-details page, so both pages share the history.
    const macId = getBatteryMacId(patient);
    if (!macId) {
      setLoadingComments(false);
      setCommentsText("");
      toast.error("Cannot load comments — MAC ID missing");
      return;
    }

    setLoadingComments(true);
    try {
      const response = await axios.get(
        `${apiUrl}api/users/getDeviceComments`,
        { params: { mac_id: macId } }
      );
      setCommentsText(response.data?.comments || "");
    } catch (error) {
      console.error("Error fetching comments:", error);
      toast.error("Error fetching comments");
    } finally {
      setLoadingComments(false);
    }
  };

  const handleCommentsSave = async () => {
    // Per-device — write to Deviceinfo.comments via /saveDeviceComments.
    const macId = getBatteryMacId(selectedPatient);
    if (!macId) {
      toast.error("Comments cannot be saved — MAC ID missing");
      return;
    }

    const newText = (newComment || "").trim();
    if (!newText) return;

    const verifiername = localStorage.getItem("verifiername") || "Unknown";
    const timestamp = new Date().toLocaleString("en-IN", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true,
    });
    const newEntry = `${newText} — ${verifiername} [${timestamp}]`;
    const existing = (commentsText || "").trim();
    const comments = existing ? `${existing}\n${newEntry}` : newEntry;

    try {
      setSavingComments(true);
      await axios.post(`${apiUrl}api/users/saveDeviceComments`, {
        mac_id: macId,
        comments,
      });

      setPatients((prev) =>
        prev.map((p) =>
          getBatteryMacId(p) === macId ? { ...p, comments } : p
        )
      );
      setCommentsText(comments);
      setNewComment("");
      setSelectedPatient((prev) => (prev ? { ...prev, comments } : prev));
      toast.success("Comment added");
    } catch (error) {
      const status = error.response?.status;
      const data = error.response?.data;
      const serverMsg =
        (typeof data === "string" && data) ||
        data?.message ||
        (typeof data?.details === "string" ? data.details : "") ||
        error.message ||
        "unknown";
      console.error("[saveDeviceComments] failed", { status, serverMsg, data, error });
      toast.error(
        status ? `Save failed (${status}): ${serverMsg}` : `Save failed: ${serverMsg}`,
        { duration: 6000 }
      );
    } finally {
      setSavingComments(false);
    }
  };

  const paginationNumbers = [];
  const startPage = Math.max(1, currentPage - 4);
  const endPage = Math.min(totalPages, startPage + 7);

  for (let i = startPage; i <= endPage; i++) {
    paginationNumbers.push(i);
  }

  return (
    <div className="wrapper theme-6-active pimary-color-green" style={{ maxWidth: "none", width: "100%" }}>
      <Toaster position="top-right" reverseOrder={false} />
      <SideBar menus={menus} />
      <div className="right-sidebar-backdrop"></div>

      <div className="page-wrapper" style={{ marginTop: "6px", background: "#041415", minHeight: "100vh", width: "100%", maxWidth: "none", padding: 0, marginRight: 0 }}>
        <div className="container-fluid" style={{ padding: 0, margin: 0, width: "100%", maxWidth: "none" }}>
          <div className="row" style={{ margin: 0 }}>
            <div className="col-sm-12" style={{ padding: 0 }}>
              <div style={{ background: "#072224", borderRadius: 0, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.25)", minHeight: "100vh" }}>

                {/* ── Compact toolbar ── */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "#0c2e32", borderBottom: "2px solid #1e6b72" }}>
                  <span style={{ color: "#ffffff", fontWeight: 700, fontSize: "14px", letterSpacing: "0.4px" }}>
                    🔋 Battery Issue
                    {filteredRows.length > 0 && (
                      <span style={{ marginLeft: 8, fontSize: "11px", fontWeight: 600, color: "#ffffff", background: "#1a6a72", borderRadius: 10, padding: "2px 10px", border: "1px solid #2a9aaa" }}>
                        {filteredRows.length} shown
                      </span>
                    )}
                  </span>
                  <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                    <span style={{ position: "absolute", left: 9, color: "#2eaabb", fontSize: "14px", pointerEvents: "none" }}>🔍</span>
                    <input
                      type="text"
                      placeholder="Search by Serial / MAC / Customer …"
                      style={{ height: 34, paddingLeft: 30, paddingRight: 10, fontSize: "12px", borderRadius: 6, border: "2px solid #2eaabb", background: "#0f4a52", color: "#ffffff", outline: "none", width: 260, fontWeight: 500, boxShadow: "0 0 0 1px rgba(46,170,187,0.3)" }}
                      value={searchQuery}
                      onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                    />
                  </div>
                </div>

                {/* ── Table — equally distributed columns ── */}
                <div style={{ padding: 0, overflowX: "auto" }}>
                  <table className="table table-striped" style={{ width: "100%", marginBottom: 0, tableLayout: "fixed" }}>
                    <colgroup>
                      <col style={{ width: "4%"  }} />  {/* SL */}
                      <col style={{ width: "16%" }} />  {/* DEVICE (Serial+MAC) */}
                      <col style={{ width: "16%" }} />  {/* Customer */}
                      <col style={{ width: "9%"  }} />  {/* Bat Start */}
                      <col style={{ width: "9%"  }} />  {/* Bat End */}
                      <col style={{ width: "10%" }} />  {/* Bat Status */}
                      <col style={{ width: "13%" }} />  {/* Callbacked By */}
                      <col style={{ width: "11%" }} />  {/* Callback Status */}
                      <col style={{ width: "12%" }} />  {/* Action */}
                    </colgroup>
                    <thead>
                      <tr style={{ background: "#031213" }}>
                        {[
                          "SL", "DEVICE", "CUSTOMER", "BAT START", "BAT END",
                          "BAT STATUS", "CALLBACKED BY", "CALLBACK", "ACTION"
                        ].map((label, i) => (
                          <th key={i} style={{
                            padding: "8px 8px",
                            textAlign: "center",
                            color: "#89a8c0",
                            fontWeight: 600,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            letterSpacing: "0.6px",
                            borderBottom: "2px solid #0c2e30",
                            borderTop: "none",
                          }}>{label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {displayedRows.map((patient, index) => {
                        const macId = patient.Mac_id || patient.mac_id || "—";
                        const serial = patient.serial_no || "—";
                        const cellStyle = {
                          verticalAlign: "middle",
                          textAlign: "center",
                          wordBreak: "break-word",
                          padding: "10px 8px",
                          fontSize: "12px",
                        };
                        const status = (patient.bat_status || patient.bat_stat || patient.Bat_status || "").toString();
                        const isNotIdeal = status.toLowerCase() === "not ideal";
                        return (
                          <tr key={patient._id || `${macId}-${index}`}>
                            <td style={cellStyle}>{startIndex + index + 1}</td>

                            {/* DEVICE — Serial bold on top, MAC lighter below */}
                            <td style={{ ...cellStyle, textAlign: "left", paddingLeft: 12 }}>
                              <div style={{ fontWeight: 700, fontSize: "13px", lineHeight: 1.3, color: "#fff" }}>
                                {serial}
                              </div>
                              <div style={{ fontSize: "11px", fontWeight: 500, opacity: 0.7, marginTop: "2px", letterSpacing: "0.3px" }}>
                                {macId}
                              </div>
                            </td>

                            <td style={cellStyle}>{getCustomerText(patient) || "—"}</td>
                            <td style={cellStyle}>{patient.bat_start || "—"}</td>
                            <td style={cellStyle}>{patient.bat_end   || "—"}</td>

                            {/* Status as colored pill */}
                            <td style={cellStyle}>
                              <span style={{
                                display: "inline-block",
                                padding: "3px 10px",
                                borderRadius: 10,
                                fontSize: "10px",
                                fontWeight: 700,
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                background: isNotIdeal ? "rgba(231,76,60,0.18)" : "rgba(39,174,96,0.18)",
                                color: isNotIdeal ? "#ff6b6b" : "#2ecc71",
                                border: `1px solid ${isNotIdeal ? "#c0392b" : "#27ae60"}`,
                              }}>
                                {status || "—"}
                              </span>
                            </td>

                            {/* Callbacked verifier name (or em-dash if not yet) */}
                            <td style={cellStyle}>
                              {patient.callbacked_verifiername
                                ? <span style={{ color: "#89c4e1", fontWeight: 600 }}>👤 {patient.callbacked_verifiername}</span>
                                : <span style={{ opacity: 0.4 }}>—</span>}
                            </td>

                            {/* Callback Status dropdown */}
                            <td style={cellStyle}>
                              <select
                                value={
                                  callbackStatusMap[getCallbackStatusKey(patient)] ||
                                  patient.callback_status ||
                                  ""
                                }
                                onChange={(e) => handleCallbackStatusChange(patient, e.target.value)}
                                style={{
                                  width: "100%",
                                  height: 30,
                                  padding: "0 8px",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  borderRadius: 6,
                                  border: "1px solid #2a9aaa",
                                  background: "#0f4a52",
                                  color: "#fff",
                                  outline: "none",
                                  cursor: "pointer",
                                }}
                              >
                                <option value="">— Select —</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </td>

                            {/* ACTION — icon buttons */}
                            <td style={cellStyle}>
                              <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                                <button
                                  type="button"
                                  title="View battery history"
                                  onClick={() => handleView(patient)}
                                  style={{
                                    width: 32, height: 32,
                                    padding: 0, margin: 0,
                                    fontSize: 15,
                                    borderRadius: 6,
                                    background: "#3498db",
                                    color: "#fff",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >👁️</button>
                                <button
                                  type="button"
                                  title="Comments"
                                  onClick={() => handleCommentsOpen(patient)}
                                  style={{
                                    width: 32, height: 32,
                                    padding: 0, margin: 0,
                                    fontSize: 15,
                                    borderRadius: 6,
                                    background: "#e67e22",
                                    color: "#fff",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                >💬</button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}

                      {displayedRows.length === 0 && (
                        <tr>
                          <td colSpan={9} style={{ textAlign: "center", padding: "30px", color: "#89a8c0", fontSize: "13px" }}>
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* ── Pagination ── */}
                <div style={{ display: "flex", justifyContent: "flex-end", padding: "10px 14px", background: "#0c2e32", borderTop: "1px solid #1e6b72", gap: 4 }}>
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    style={{
                      border: "1px solid #2a9aaa",
                      padding: "5px 12px",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      borderRadius: 5,
                      background: currentPage === 1 ? "#1a3a3e" : "#0f4a52",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 600,
                      opacity: currentPage === 1 ? 0.5 : 1,
                    }}
                  >Prev</button>
                  {paginationNumbers.map((num) => (
                    <button
                      key={num}
                      onClick={() => setCurrentPage(num)}
                      style={{
                        fontWeight: 700,
                        background: num === currentPage ? "#2eaabb" : "#0f4a52",
                        color: "#fff",
                        border: `1px solid ${num === currentPage ? "#2eaabb" : "#2a9aaa"}`,
                        padding: "5px 12px",
                        cursor: "pointer",
                        borderRadius: 5,
                        fontSize: 12,
                      }}
                    >{num}</button>
                  ))}
                  <button
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    style={{
                      border: "1px solid #2a9aaa",
                      padding: "5px 12px",
                      cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                      borderRadius: 5,
                      background: currentPage === totalPages ? "#1a3a3e" : "#0f4a52",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 600,
                      opacity: currentPage === totalPages ? 0.5 : 1,
                    }}
                  >Next</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Battery Records modal — modern card UI matching the rest of the page ── */}
      <Modal
        isOpen={showBatteryModal}
        onRequestClose={() => setShowBatteryModal(false)}
        contentLabel="Battery Issue Details"
        style={{
          overlay: { background: "rgba(0,0,0,0.5)", zIndex: 1050 },
          content: {
            padding: 0,
            border: "none",
            borderRadius: 10,
            overflow: "hidden",
            boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
            width: "92%",
            maxWidth: 760,
            maxHeight: "85vh",
            top: "50%", left: "50%", right: "auto", bottom: "auto",
            transform: "translate(-50%, -50%)",
            marginRight: "-50%",
            background: "#072224",
          },
        }}
      >
        {/* Header */}
        <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>
              🔋 Battery History
            </div>
            {selectedPatient && (
              <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>
                {selectedPatient.serial_no || "—"}
                <span style={{ color: "#5a8fa8", marginLeft: 6, fontSize: "11px" }}>
                  {selectedPatient.Mac_id || selectedPatient.mac_id || ""}
                </span>
                {getCustomerText(selectedPatient) && getCustomerText(selectedPatient) !== "_" && (
                  <span style={{ color: "#5a8fa8", marginLeft: 8, fontSize: "11px" }}>
                    · {getCustomerText(selectedPatient)}
                  </span>
                )}
              </div>
            )}
          </div>
          <button type="button"
            onClick={() => setShowBatteryModal(false)}
            style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: 16, lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          >×</button>
        </div>

        {/* Body */}
        <div style={{ background: "#072224", maxHeight: "calc(85vh - 110px)", overflowY: "auto", padding: "14px 16px" }}>
          {loadingBattery ? (
            <div style={{ padding: "30px 16px", textAlign: "center", color: "#89a8c0", fontSize: "13px" }}>Loading…</div>
          ) : batteryData.length === 0 ? (
            <div style={{ padding: "30px 16px", textAlign: "center", color: "#89a8c0", fontSize: "13px" }}>No battery details found</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {batteryData.map((item, index) => {
                const status = (item.bat_stat || "").toLowerCase();
                const isNotIdeal = status === "not ideal";
                const fmtTime = (t) => {
                  if (!t) return "—";
                  try {
                    const d = new Date(t);
                    if (isNaN(d)) return t;
                    return d.toLocaleString("en-IN", {
                      day: "2-digit", month: "short", year: "numeric",
                      hour: "2-digit", minute: "2-digit", hour12: true,
                    });
                  } catch (e) { return t; }
                };
                const Field = ({ label, value }) => (
                  <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
                    <div style={{ color: "#5a8fa8", fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 2 }}>{label}</div>
                    <div style={{ color: "#e2eef2", fontSize: 13, fontWeight: 500, wordBreak: "break-word" }}>{value || "—"}</div>
                  </div>
                );
                return (
                  <div
                    key={item._id || index}
                    style={{
                      background: "#0c2e32",
                      border: "1px solid #1e6b72",
                      borderRadius: 8,
                      padding: "12px 14px",
                    }}
                  >
                    {/* Top row — patient + status pill */}
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10, gap: 10 }}>
                      <div>
                        <div style={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>
                          {item.patient_name || "Unknown patient"}
                        </div>
                        <div style={{ color: "#89a8c0", fontSize: 11, marginTop: 2 }}>
                          📅 {fmtTime(item.timestamp)}
                        </div>
                      </div>
                      <span style={{
                        display: "inline-block",
                        padding: "3px 10px",
                        borderRadius: 10,
                        fontSize: 10,
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        background: isNotIdeal ? "rgba(231,76,60,0.18)" : "rgba(39,174,96,0.18)",
                        color: isNotIdeal ? "#ff6b6b" : "#2ecc71",
                        border: `1px solid ${isNotIdeal ? "#c0392b" : "#27ae60"}`,
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                      }}>
                        {item.bat_stat || "—"}
                      </span>
                    </div>

                    {/* Battery progress visualisation */}
                    <div style={{ marginBottom: 10 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", color: "#89a8c0", fontSize: 10, marginBottom: 4 }}>
                        <span>🔋 START: <strong style={{ color: "#2ecc71" }}>{item.bat_start || "—"}{item.bat_start ? "%" : ""}</strong></span>
                        <span>🪫 END: <strong style={{ color: isNotIdeal ? "#ff6b6b" : "#f39c12" }}>{item.bat_end || "—"}{item.bat_end ? "%" : ""}</strong></span>
                      </div>
                      {(() => {
                        const start = parseInt(item.bat_start, 10);
                        const end = parseInt(item.bat_end, 10);
                        if (!isFinite(start) || !isFinite(end)) return null;
                        return (
                          <div style={{ height: 8, width: "100%", background: "#031213", borderRadius: 4, overflow: "hidden", position: "relative" }}>
                            <div style={{
                              height: "100%",
                              width: `${end}%`,
                              background: isNotIdeal
                                ? "linear-gradient(90deg,#e74c3c,#ff6b6b)"
                                : "linear-gradient(90deg,#27ae60,#2ecc71)",
                              transition: "width 0.3s ease",
                            }} />
                          </div>
                        );
                      })()}
                    </div>

                    {/* Detail grid */}
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                      gap: "8px 12px",
                    }}>
                      <Field label="Device ID"  value={item.device_id} />
                      <Field label="MAC ID"     value={item.mac_id} />
                      <Field label="Use Days"   value={item.exp_device_use_days != null ? `${item.exp_device_use_days}` : ""} />
                      <Field
                        label="Callbacked By"
                        value={item.callbacked_verifiername
                          ? <span style={{ color: "#89c4e1" }}>👤 {item.callbacked_verifiername}</span>
                          : "—"}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: "10px 16px", background: "#0c2e32", borderTop: "1px solid #1e6b72", display: "flex", justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={() => setShowBatteryModal(false)}
            style={{
              padding: "7px 22px",
              fontSize: 13,
              background: "#0f4a52",
              border: "1px solid #2a9aaa",
              borderRadius: 6,
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </Modal>

      {/* ── Comments modal — threaded UI matching patient-list ── */}
      <Modal
        isOpen={showCommentsModal}
        onRequestClose={() => { setShowCommentsModal(false); setNewComment(""); }}
        contentLabel="Comments"
        style={{
          overlay: { background: "rgba(0,0,0,0.5)", zIndex: 1050 },
          content: {
            padding: 0,
            border: "none",
            borderRadius: 10,
            overflow: "hidden",
            boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
            width: "94%",
            maxWidth: 860,
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            marginRight: "-50%",
            background: "#fff",
          },
        }}
      >
        {/* Header */}
        <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>
              💬 Support Comments
            </div>
            {selectedPatient && (
              <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>
                {selectedPatient.serial_no || "—"}
                <span style={{ color: "#5a8fa8", marginLeft: 6, fontSize: "11px" }}>
                  {selectedPatient.Mac_id || selectedPatient.mac_id || ""}
                </span>
              </div>
            )}
          </div>
          <button
            type="button"
            onClick={() => { setShowCommentsModal(false); setNewComment(""); }}
            style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: "16px", lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            ×
          </button>
        </div>

        {/* Comment History */}
        {loadingComments ? (
          <div style={{ padding: "30px 16px", textAlign: "center", color: "#666", fontSize: "13px", background: "#f5f7fa" }}>
            Loading…
          </div>
        ) : (() => {
          const raw = (commentsText || "").trim();
          const lines = (raw ? raw.split("\n").filter((l) => l.trim()) : []).reverse(); // newest first
          return (
            <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e2e8f0", maxHeight: "calc(100vh - 360px)", minHeight: 120, overflowY: "auto", padding: lines.length ? "12px 16px" : "0" }}>
              {lines.length === 0 ? (
                <div style={{ padding: "18px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>No comments yet</div>
              ) : (
                lines.map((line, idx) => {
                  const byMatch =
                    line.match(/^(.*?)\s*[—–-]+\s*BY\s+(.+?)(?:\s*\[(.+?)\])?$/i) ||
                    line.match(/^(.*?)\s*—\s*(.+?)(?:\s*\[(.+?)\])?$/);
                  const text = byMatch ? byMatch[1].trim() : line;
                  const author = byMatch ? byMatch[2].trim() : "";
                  const time = byMatch ? byMatch[3] || "" : "";
                  const initials = author
                    ? author.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()
                    : "?";
                  const colors = ["#3498db", "#9b59b6", "#1abc9c", "#e67e22", "#e74c3c", "#2ecc71"];
                  const avatarColor = colors[initials.charCodeAt(0) % colors.length];
                  return (
                    <div key={idx} style={{ display: "flex", gap: 10, marginBottom: idx < lines.length - 1 ? 12 : 0 }}>
                      <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatarColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, flexShrink: 0, marginTop: 2 }}>
                        {initials}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "8px 12px", fontSize: "13px", color: "#2d3748", lineHeight: 1.5, whiteSpace: "pre-line", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                          {text.replace(/^\[[A-Za-z]+\][^|]*\|\s*/, "")}
                        </div>
                        <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: 3, paddingLeft: 2 }}>
                          <span style={{ fontWeight: 600, color: "#64748b" }}>{author || (/^\[[A-Za-z]+\][^|]*\|/.test(text) ? "System · " + text.split("|")[0].replace(/[\[\]]/g, "").trim() : "Unknown")}</span>
                          {time && <span style={{ marginLeft: 6 }}>{time}</span>}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          );
        })()}

        {/* New Comment Input */}
        <div style={{ background: "#fff", padding: "14px 16px 10px" }}>
          <div style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>
            Add New Comment
          </div>
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Type your observation, finding or note here…"
            maxLength={300}
            rows={3}
            style={{ width: "100%", fontSize: "13px", color: "#2d3748", border: "1px solid #cbd5e0", borderRadius: 6, padding: "10px 12px", resize: "none", outline: "none", fontFamily: "inherit", lineHeight: 1.6, transition: "border-color 0.2s" }}
            onFocus={(e) => (e.target.style.borderColor = "#4299e1")}
            onBlur={(e) => (e.target.style.borderColor = "#cbd5e0")}
          />
          <div style={{ textAlign: "right", fontSize: "11px", color: newComment.length > 250 ? "#e74c3c" : "#94a3b8", marginTop: 3 }}>
            {newComment.length}/300
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: "8px 16px 14px", background: "#fff", display: "flex", justifyContent: "flex-end", gap: 8, borderTop: "1px solid #f0f0f0" }}>
          <button
            type="button"
            onClick={() => { setShowCommentsModal(false); setNewComment(""); }}
            style={{ padding: "7px 20px", fontSize: "13px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleCommentsSave}
            disabled={savingComments || loadingComments || !newComment.trim()}
            style={{
              padding: "7px 22px",
              fontSize: "13px",
              background: newComment.trim() ? "#1e8449" : "#a8d5b5",
              border: "none",
              borderRadius: 6,
              color: "#fff",
              fontWeight: 700,
              cursor: newComment.trim() ? "pointer" : "not-allowed",
              transition: "background 0.2s",
            }}
          >
            ✓ Add Comment
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default BatteryIssue;
